import { render } from "./DepartmentDetailsAdmin.vue?vue&type=template&id=7575c345&scoped=true&ts=true"
import script from "./DepartmentDetailsAdmin.vue?vue&type=script&lang=ts"
export * from "./DepartmentDetailsAdmin.vue?vue&type=script&lang=ts"

import "./DepartmentDetailsAdmin.vue?vue&type=style&index=0&id=7575c345&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7575c345"]])

export default __exports__